import React from "react";
import { Reveal } from "../tools/Reveal";
import { RevealGroup } from "../tools/RevealGroup";
import profilePic from "../images/profile-picture-1.jpeg";
import "../styles/Intro.scss";

function Intro() {
  return (
    <div className="intro" id="home-page">
      <RevealGroup>
        <div className="intro-left">
          <Reveal direction="left">
            <div className="intro-text-wrapper">
              <h4 className="intro-title">Welcome to my portfolio</h4>
              <p className="intro-text">
                Hello, I'm Feridun Canselen. A full-stack developer delivering
                pixel-perfect, high-performance applications with seamless user
                experiences.
              </p>
            </div>
            <div className="intro-button-wrapper">
              <a href="#contact-me">
                <button className="intro-button">Let's work together</button>
              </a>
            </div>
          </Reveal>
        </div>
        <div className="intro-right">
          <Reveal direction="right">
            <img
              src={profilePic}
              className="intro-image"
              alt="Headshot of Feridun Canselen with a park background."
            />
          </Reveal>
        </div>
      </RevealGroup>
    </div>
  );
}
export default Intro;
